import { IVR } from '@pwp-common';

import { RowCell } from '../../../../../common/p-table/row-cell';

import { IVREditorRow } from './interfaces';

//////////////////////////////////////////////////////////////////////////////////////////
// IVR editor row
//////////////////////////////////////////////////////////////////////////////////////////

export const createIVREditorRow = (ivr: IVR): IVREditorRow => ({
  id: ivr.getId(),
  displayName: createValueCell(ivr.getDisplayName()),
  description: createValueCell(ivr.getDescription()),
  optionsCount: createOptionsCountCell(ivr.getOptions().length),
  ivr,
});

//////////////////////////////////////////////////////////////////////////////////////////
// Value cell
//////////////////////////////////////////////////////////////////////////////////////////

const createValueCell = (value: string): RowCell<string> =>
  new RowCell<string>({
    translationScope: 'ivr-table-editor',
    translationKey: 'cellValue',
    translationObj: { value },
    sortValue: value,
  });

const createOptionsCountCell = (count: number): RowCell<number> =>
  new RowCell<number>({
    translationScope: 'ivr-table-editor',
    translationKey: 'optionsCountValue',
    translationObj: { count },
    sortValue: count,
  });

